import {
  ModalContainer,
  ModalLayoutSlideUp,
} from '@kanda-libs/ks-design-library';
import type { MutableRefObject, ReactNode } from 'react';

export interface OpenBankingInfoMobileModalProps {
  children: ReactNode;
}

const OpenBankingInfoMobileModal: React.FunctionComponent<OpenBankingInfoMobileModalProps> =
  function ({ children }) {
    return (
      <ModalContainer id="open-banking-info">
        {({ id, handleClose, ref }) => (
          <ModalLayoutSlideUp
            id={id}
            onClose={handleClose}
            ref={ref as MutableRefObject<HTMLDivElement>}
          >
            <div className="flex flex-col">{children}</div>
          </ModalLayoutSlideUp>
        )}
      </ModalContainer>
    );
  };

export default OpenBankingInfoMobileModal;
